import React, { useState } from "react";
import { AiOutlineCloseCircle } from "react-icons/ai";
import Box from "@mui/material/Box";
import { toAbsoluteUrl } from "../../services";
import Button from "../button/button";
import Dropdown from "../dropdown/dropdown";
import { MenuAlt2Icon } from "@heroicons/react/solid";
import ModalVideo from "react-modal-video";
import { handleMainTab } from "../../redux/actions/free/homeActions";
import { loadCampaigns } from "../../redux/actions/free/dashboardActions";
import { connect, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ROUTES from "../../free/constants/routes";
import { ProgressBar, IconButton } from "..";
import { AiOutlinePlus } from "react-icons/ai";
import Modal from "@mui/material/Modal";
import { useEffect } from "react";
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  overflow: "none",
  marginTop: "2%",
  marginBottom: "2%",
};

// get step data from redux main state
const data = (state) => state.dashboard;
// get step data from redux main state
const authDetails = (state) => state.auth;

function MainLayout(props) {
  const [mobileMenu, setMobileMenu] = useState(false);
  const [isOpen, setOpen] = useState(false);
  const [campaignsCount, setCampaignsCount] = useState(null);
  const [isRun, setIsRun] = useState(false);
  const [isNotCampaign, setIsNotCampaign] = useState(false);
  let navigate = useNavigate();
  let clientData = useSelector(data);
  let authData = useSelector(authDetails);
  let { campaigns } = clientData;

  let { userType } = authData;
  let handleMenu = () => {
    setMobileMenu(!mobileMenu);
  };

  let decidetoGo = (count) => {
    if (isRun && count > 0) {
      navigate(`${ROUTES.REPORT}`);
    } else if (count < 1) {
      setIsNotCampaign(true);
    } else {
    }
  };
  let handleReport = async () => {
    await props.loadCampaigns();
    setIsRun(true);
  };

  useEffect(() => {
    let totalCamps = campaigns && campaigns.length;
    setCampaignsCount(totalCamps);
    if (totalCamps > 0) {
      decidetoGo(totalCamps);
    }
  }, [campaigns]);

  let { gameCompletion, showProgress, showDashboardButton } = props;

  return (
    <div className="w-full">
      {/* Header Start */}
      <div
        className="bg-cover px-[8%] 2xl:h-[17rem] xl:h-[17rem] lg:h-[17rem] md:h-[17rem]  h-[21rem]"
        style={{
          backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg.png")})`,
          width: "100%",
          backgroundPosition: "center",
        }}
      >
        {/* <!-- Navbar goes here --> */}
        <nav>
          <div className="mx-auto">
            <div className="flex 2xl:justify-around xl:justify-around lg:justify-around justify-between">
              <div className="flex ">
                <div>
                  {/* <!-- Website Logo --> */}
                  <div className="cursor-pointer flex items-center py-6 ">
                    <img
                      alt="Logo"
                      src={toAbsoluteUrl("/media/home/logo.png")}
                    />
                  </div>
                </div>
                {/* <!-- Primary Navbar items --> */}
                <div className="hidden md:flex items-center ">
                  <span
                    onClick={() => navigate(`${ROUTES.DASHBOARD}`)}
                    className="text-[#5D5959] font-semibold py-6 px-2 mx-4  text-[17px] cursor-pointer"
                  >
                    Dashboard
                  </span>

                  <span
                    className={`${"text-[#5D5959] font-semibold py-6 px-2 text-[17px] mx-4 cursor-pointer"}`}
                    onClick={() => handleReport()}
                  >
                    Candidate Applications
                  </span>

                  <span
                    onClick={() => {
                      window.open(
                        "https://assessments.thetalent.games/#/test-library",
                        "_blank"
                      );
                    }}
                    className="text-[#5D5959] font-semibold py-6 px-2  mx-4 text-[17px] cursor-pointer"
                  >
                    Assessment Library
                  </span>
                </div>
              </div>
              {/* <!-- Secondary Navbar items --> */}
              <div className="hidden md:flex items-center">
                <Button
                  onClick={() => setOpen(!isOpen)}
                  name="Explainer Video"
                />
                <Dropdown
                  logout={props.logout}
                  stepHandler={props.handleMainTab}
                  showIsCampaign={(type) => setIsNotCampaign(type)}
                />
              </div>
              {/* <!-- Mobile menu button --> */}
              <div className="md:hidden flex items-center">
                <button
                  onClick={handleMenu}
                  className="outline-none mobile-menu-button"
                >
                  <MenuAlt2Icon className="h-5 w-5 text-white" />
                </button>
              </div>
            </div>
          </div>
          {/* <!-- mobile menu --> */}
          {mobileMenu ? (
            <div className="2xl:hidden xl:hidden lg:hidden md:hidden mobile-menu ">
              <ul className="">
                <li className="active">
                  <span
                    onClick={() => navigate(`${ROUTES.DASHBOARD}`)}
                    className="block text-[#5D5959] font-semibold py-2 px-10  text-md "
                  >
                    Dashboard
                  </span>
                </li>
                <li>
                  <span
                    onClick={() => handleReport()}
                    className="block text-[#5D5959] font-semibold py-2 px-10  text-md "
                  >
                    Candidate Applications
                  </span>
                </li>
                <li>
                  <span
                    onClick={() => {
                      window.open(
                        "https://saastesting.thetalent.games/#/test-library",
                        "_blank"
                      );
                    }}
                    className="block text-[#5D5959] font-semibold py-2 px-10  text-md "
                  >
                    Assessment Library
                  </span>
                </li>
              </ul>

              {/* <!-- Secondary Navbar items --> */}
              <div className=" items-center space-x-3  ml-9 mt-2">
                <Button
                  onClick={() => setOpen(!isOpen)}
                  name="Explainer Video"
                />
                <div className="mt-2">
                  <Dropdown
                    logout={props.logout}
                    stepHandler={props.handleMainTab}
                  />
                </div>
              </div>
            </div>
          ) : null}
        </nav>
        {!showProgress ? null : (
          <div className="flex justify-end mt-6 mx-10">
            <div className="2xl:w-3/12 xl:w-3/12 lg:2-4/12 md:w-6/12 w-8/12">
              <div className="flex justify-between items-center w-full">
                <p className="font-bold text-[#56452C] text-xl -ml-0 ">
                  Game Creation
                </p>
                <p className="font-bold text-[#007E8C] text-xl">
                  {gameCompletion ? gameCompletion : 0}%
                </p>
              </div>
              <ProgressBar value={gameCompletion} />
            </div>
          </div>
        )}
        {!showDashboardButton ? null : (
          <div className="flex justify-end mt-24 mx-6">
            <div className="2xl:w-3/12 xl:w-3/12 lg:2-4/12 md:w-6/12 w-8/12">
              <IconButton
                onClick={props.onClick}
                name="Create New Assessment Game"
                customStyle="px-6 py-3 font-bold"
              >
                <AiOutlinePlus className="mt-1 h-5 w-5 text-white" />
              </IconButton>
            </div>
          </div>
        )}
      </div>
      {/* Body Start */}

      <div>
        {isOpen ? (
          <ModalVideo
            channel="youtube"
            autoplay
            isOpen={isOpen}
            videoId={`${
              userType === "free"
                ? "Z3hYshxsIo8"
                : userType === "standard"
                ? "Df59dHGQWCQ"
                : userType === "premium"
                ? "pP0b39hBpfs"
                : null
            }`}
            onClose={() => setOpen(false)}
          />
        ) : null}

        {isNotCampaign ? (
          <div>
            <Modal
              open={isNotCampaign}
              onClose={() => {
                setIsNotCampaign(false);
              }}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
            >
              <Box
                sx={style}
                className="border-4 border-[#0094A5] rounded-lg bg-white shadow-md  2xl:w-4/12 xl:w-4/12 lg:w-4/12 md:w-6/12 w-8/12 my-14"
              >
                <div className="border-[3px] border-[#FFD700] rounded-md">
                  <div className="flex justify-end items-center px-4 py-3">
                    <button onClick={() => setIsNotCampaign(false)}>
                      <AiOutlineCloseCircle color="#0094A5" size={25} />
                    </button>
                  </div>
                  <div className="px-8 py-2">
                    <h5 className="text-[#515556] text-2xl font-semibold text-center">
                      Create A New Assessment Game
                    </h5>
                    <p className="text-[#414141] font-medium text-[15px] my-4 mt-6 text-center">
                      No candidate report available as you haven't created any
                      assessment game. Please create an assessment game to view
                      your candidate applications.
                    </p>
                    <div className="my-6 px-14"></div>
                  </div>
                </div>
              </Box>
            </Modal>
          </div>
        ) : null}

        {props.children}
      </div>

      {/* Body End */}
    </div>
  );
}

const mapStateToProps = ({ state }) => ({
  state,
});

export default connect(mapStateToProps, {
  handleMainTab,
  loadCampaigns,
})(MainLayout);
